__turbopack_context__.v({
  "actions": "CShopInpostPicker-module__NRpX-q__actions",
  "body": "CShopInpostPicker-module__NRpX-q__body",
  "cancelBtn": "CShopInpostPicker-module__NRpX-q__cancelBtn",
  "confirmBtn": "CShopInpostPicker-module__NRpX-q__confirmBtn",
  "dialog": "CShopInpostPicker-module__NRpX-q__dialog",
  "dialogCloseBtn": "CShopInpostPicker-module__NRpX-q__dialogCloseBtn",
  "dialogContent": "CShopInpostPicker-module__NRpX-q__dialogContent",
  "dialogFooter": "CShopInpostPicker-module__NRpX-q__dialogFooter",
  "dialogHeader": "CShopInpostPicker-module__NRpX-q__dialogHeader",
  "dialogTitle": "CShopInpostPicker-module__NRpX-q__dialogTitle",
  "errorMessage": "CShopInpostPicker-module__NRpX-q__errorMessage",
  "heading": "CShopInpostPicker-module__NRpX-q__heading",
  "mapCanvas": "CShopInpostPicker-module__NRpX-q__mapCanvas",
  "mapUnavailable": "CShopInpostPicker-module__NRpX-q__mapUnavailable",
  "mapWrap": "CShopInpostPicker-module__NRpX-q__mapWrap",
  "modalError": "CShopInpostPicker-module__NRpX-q__modalError",
  "modalErrorClose": "CShopInpostPicker-module__NRpX-q__modalErrorClose",
  "nearestBtn": "CShopInpostPicker-module__NRpX-q__nearestBtn",
  "notSelected": "CShopInpostPicker-module__NRpX-q__notSelected",
  "resultAddress": "CShopInpostPicker-module__NRpX-q__resultAddress",
  "resultItem": "CShopInpostPicker-module__NRpX-q__resultItem",
  "resultName": "CShopInpostPicker-module__NRpX-q__resultName",
  "results": "CShopInpostPicker-module__NRpX-q__results",
  "resultsEmpty": "CShopInpostPicker-module__NRpX-q__resultsEmpty",
  "resultsList": "CShopInpostPicker-module__NRpX-q__resultsList",
  "resultsLoading": "CShopInpostPicker-module__NRpX-q__resultsLoading",
  "root": "CShopInpostPicker-module__NRpX-q__root",
  "searchInput": "CShopInpostPicker-module__NRpX-q__searchInput",
  "searchRow": "CShopInpostPicker-module__NRpX-q__searchRow",
  "selected": "CShopInpostPicker-module__NRpX-q__selected",
  "selectedAddress": "CShopInpostPicker-module__NRpX-q__selectedAddress",
  "selectedCard": "CShopInpostPicker-module__NRpX-q__selectedCard",
  "selectedCardAddress": "CShopInpostPicker-module__NRpX-q__selectedCardAddress",
  "selectedCardClear": "CShopInpostPicker-module__NRpX-q__selectedCardClear",
  "selectedCardHeader": "CShopInpostPicker-module__NRpX-q__selectedCardHeader",
  "selectedCardLabel": "CShopInpostPicker-module__NRpX-q__selectedCardLabel",
  "selectedCardName": "CShopInpostPicker-module__NRpX-q__selectedCardName",
  "selectedDescription": "CShopInpostPicker-module__NRpX-q__selectedDescription",
  "selectedName": "CShopInpostPicker-module__NRpX-q__selectedName",
});
